/* Cart: AJAX add to cart from any product form, drawer re-rendered through the Section Rendering API,
   line quantity changes, removal, note, and the off-road disclaimer gate before checkout. */
(function () {
  'use strict';
  var ST = window.ST || {};
  var drawer = document.getElementById('CartDrawer');
  var toast = document.getElementById('CartToast');
  var busy = false;

  function money(cents) {
    var fmt = ST.money || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  function renderDrawer(html) {
    if (!drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer .panel-body') || doc.querySelector('.panel-body');
    var current = drawer.querySelector('.panel-body');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    loadXsell();
  }

  /* ---------- One complementary add-on in the drawer (theme setting "Offer one add-on in the cart") ----------
     Uses Shopify's own recommendations for the first line. Picks one in-stock, single-variant product that is
     not already in the cart and costs at most 35% of the subtotal (complementary, never a bigger item). */
  function loadXsell() {
    var slot = drawer && drawer.querySelector('[data-cart-xsell]');
    if (!slot || !slot.dataset.productId) return;
    var inCart = (slot.dataset.inCart || '').split(',').filter(Boolean);
    var subtotal = parseInt(slot.dataset.subtotal, 10) || 0;
    var root = (ST.routes.root || '/').replace(/\/$/, '');
    fetch(root + '/recommendations/products.json?product_id=' + slot.dataset.productId + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var pick = (data.products || []).filter(function (p) {
          /* never offer a tune or bundle as a one-tap add-on: those need their option choices on the product page */
          var isTune = /tun(e|ing)|bundle/i.test((p.title || '') + ' ' + (p.type || '') + ' ' + (p.tags || []).join(' '));
          return !isTune && inCart.indexOf(String(p.id)) === -1 && p.available && p.variants && p.variants.length === 1 && p.variants[0].available && p.variants[0].price <= Math.max(subtotal * 0.35, 6000);
        })[0];
        if (!pick) { slot.hidden = true; return; }
        var v = pick.variants[0];
        var img = pick.featured_image ? '<img src="' + pick.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2') + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>';
        slot.innerHTML = '<p class="cart-xsell-head">' + slot.dataset.heading + '</p><div class="cart-xsell-item">' + img +
          '<div><a href="' + pick.url + '">' + pick.title + '</a><span class="mono">' + money(v.price) + '</span></div>' +
          '<button type="button" class="btn btn-sm btn-navy" data-xsell-add="' + v.id + '">' + slot.dataset.addLabel + '</button></div>';
        slot.hidden = false;
      })
      .catch(function () { slot.hidden = true; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-xsell-add]');
    if (!b || busy) return;
    busy = true; b.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', b.dataset.xsellAdd); fd.append('quantity', '1'); fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname);
    fetch(ST.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || ST.strings.error);
        if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
        return fetch(ST.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartTotals(cart);
          document.dispatchEvent(new CustomEvent('st:cart:added', { detail: { item: data, cart: cart } }));
        });
      })
      .catch(function (err) { var box = document.querySelector('[data-cart-error]'); if (box) { box.textContent = err.message; box.hidden = false; } })
      .finally(function () { busy = false; });
  });

  function refreshDrawer() {
    return fetch(ST.routes.root + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.panel-body');
      var current = drawer && drawer.querySelector('.panel-body');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      loadXsell();
    });
  }

  function showToast(item) {
    if (!toast) return;
    var img = toast.querySelector('img'), title = toast.querySelector('[data-toast-title]');
    if (img) { if (item && item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2'); img.hidden = false; } else { img.hidden = true; } }
    if (title) title.textContent = item ? item.product_title : ST.strings.added;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  function updateCartTotals(cart) {
    setCount(cart.item_count);
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(ST.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || data.message || ST.strings.error); }
        if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
        return fetch(ST.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartTotals(cart);
          if (ST.cartType === 'drawer' && drawer) { window.ST.openPanel(drawer); }
          else if (ST.cartType === 'page') { window.location.href = ST.routes.cart; }
          else { showToast(data); }
          if (btn) { btn.innerHTML = '<span>' + ST.strings.added + '</span>'; setTimeout(function () { btn.innerHTML = original; }, 1800); }
          document.dispatchEvent(new CustomEvent('st:cart:added', { detail: { item: data, cart: cart } }));
        });
      })
      .catch(function (err) {
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        else alert(err.message);
      })
      .finally(function () {
        busy = false;
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  });

  /* ---------- Line changes inside drawer or cart page ---------- */
  function changeLine(line, quantity, el) {
    var row = el && el.closest('[data-cart-line]');
    if (row) row.classList.add('is-busy');
    var body = { line: line, quantity: quantity, sections: 'cart-drawer,main-cart', sections_url: window.location.pathname };
    return fetch(ST.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);
        updateCartTotals(cart);
        if (cart.sections) {
          if (cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']);
          var main = document.getElementById('MainCart');
          if (main && cart.sections['main-cart']) {
            var doc = new DOMParser().parseFromString(cart.sections['main-cart'], 'text/html');
            var fresh = doc.getElementById('MainCart');
            if (fresh) main.innerHTML = fresh.innerHTML;
          }
        }
        document.dispatchEvent(new CustomEvent('st:cart:changed', { detail: { cart: cart } }));
      })
      .catch(function (err) {
        var box = document.querySelector('[data-cart-error]');
        if (box) { box.textContent = err.message || ST.strings.error; box.hidden = false; }
        if (row) row.classList.remove('is-busy');
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10) || 0, input);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.dataset.lineRemove, 10), 0, rm);
  });

  /* ---------- Cart note ---------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(ST.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }, 500);
  });

  /* ---------- Disclaimer gate ----------
     Runs in the CAPTURE phase at document level so it fires before any app script.
     Ymq Product Options wraps the checkout button in its own <span>, takes the click
     first and puts the button into a loading state; if we blocked the click after
     that, Ymq never finished and the button went dead. Blocking here means Ymq never
     sees a click that the shopper has not agreed to. */
  function checkoutButtonFrom(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('[name="checkout"], [data-checkout]');
    if (!btn && target.querySelector) {
      var inner = target.querySelector('[name="checkout"], [data-checkout]');
      if (inner && inner.parentElement === target) btn = inner; /* click landed on the Ymq wrapper */
    }
    return btn;
  }
  function unstickCheckout(form) {
    form.querySelectorAll('[name="checkout"], [data-checkout]').forEach(function (b) {
      b.classList.remove('ymq-option-loading', 'ymq-option-loading-dark');
    });
  }
  document.addEventListener('click', function (e) {
    var checkout = checkoutButtonFrom(e.target);
    if (!checkout) return;
    var form = checkout.closest('form');
    if (!form) return;
    var box = form.querySelector('[data-disclaimer]');
    if (!box) return;
    var wrap = box.closest('.cart-disclaimer');
    var host = form.closest('.cart-drawer') || form.closest('main') || form;
    var msg = host.querySelector('[data-cart-error]');
    if (!box.checked) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (wrap) { wrap.classList.add('is-missing'); wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      if (msg) { msg.textContent = ST.strings.disclaimer; msg.hidden = false; }
      unstickCheckout(form);
      box.focus();
      return;
    }
    if (wrap) wrap.classList.remove('is-missing');
    if (msg) msg.hidden = true;
    unstickCheckout(form);
  }, true);
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-disclaimer]');
    if (!box) return;
    var wrap = box.closest('.cart-disclaimer');
    if (wrap) wrap.classList.toggle('is-missing', !box.checked);
    var msg = document.querySelector('[data-cart-error]');
    if (msg && box.checked) msg.hidden = true;
    if (box.checked && box.form) unstickCheckout(box.form);
    try { sessionStorage.setItem('st_disclaimer', box.checked ? '1' : ''); } catch (err) {}
  });
  /* remember the tick while they browse */
  function restoreDisclaimer() {
    try {
      if (sessionStorage.getItem('st_disclaimer') === '1') document.querySelectorAll('[data-disclaimer]').forEach(function (b) { b.checked = true; });
    } catch (err) {}
  }
  restoreDisclaimer();
  if (drawer) drawer.addEventListener('st:open', function () { refreshDrawer().then(restoreDisclaimer); });
  document.addEventListener('st:cart:changed', restoreDisclaimer);
  document.addEventListener('st:cart:added', restoreDisclaimer);

  /* Open the drawer when the header cart is clicked (drawer mode) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open]');
    if (!a || ST.cartType !== 'drawer' || !drawer) return;
    e.preventDefault();
    window.ST.openPanel(drawer);
  });
})();
